<template>
    <div>
        <swb-query-sort-area name="query_model_ctrl" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed"
                          :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler"
                          :rowDblClickHandler="rowDblClickHandler"></swb-result-table>

    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, Routes, DomSizeWatcher} from '../../app.vues'
    import {getDefaultPageSizes} from '../../app.conf';
    import {checkUserActionPerm} from '../index'
    import {openLogisComSetDlg} from '../merchtLogis/showDlg'
    import {showRouteLayer} from '../ctrl/RouteLayer';
    //
    import goodsDelivApi from '../../api/goodsDeliv'

    import SwbGoodsReturnVoucherInfo from './GoodsReturnVoucherInfo';
    Vue.regist(SwbGoodsReturnVoucherInfo);
    import SwbShowGoodsOrder from './ShowGoodsOrder';
    Routes.add(SwbShowGoodsOrder);
    //
    import SwbTradeVoucherList from '../tradeVoucher/TradeVoucherList';
    Routes.add(SwbTradeVoucherList);

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "label": "退货单号",
            "code": "no",
            "valueType": "String",
            "basic": true
        }, {
            "type": "Text",
            "label": "订单号",
            "code": "orderNo",
            "valueType": "String",
            "basic": true
        }, {
            "type": "Text",
            "label": "商户名称",
            "code": "sellerComName",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Date2",
            "valueType": "String",
            "label": "创建时间",
            "code": "createTime",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "退货机构",
            "code": "buyerShopName"
        }],
        "sortFields": [{
            "label": "创建时间",
            "code": "createTime",
            "order": "desc",
            "enabled": true
        }]
    };

    export default {
        name: 'swb-goods-return-voucher-list',
        path: '/goods/return/voucher/list',
        avlActions: 'to_trade_voucher|to_order_list|view_detail|to_ship',
        avlActionNames: '详情、发货',
        avlScopes: 'retailer',
        desc: '退货单列表',
        data: function () {
            return {
                confKey: 'swb-goods-return-voucher-list',
                theTableHeight: 300,
                queryOnLoad: true,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: true, //行号列是否固定（默认：false）
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 260,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //排序、搜索
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                goodsRecvVoucherList: [],
                no: null
            }
        },
        created: function () {
            //
            this.pageSize = this.pageSizes.first();
            //----------------------搜索排序----------------------------
            //查询排序配置信息
            let queryConfig = searchConfigData || {};
            //查询回调函数调用上下文对象
            //queryConfig.queryContext = this;
            //
            this.queryConfig = queryConfig;
            // --------------------查询--------------------------------
            this.getGoodsRecvVouchers();
        },

        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="query_model_ctrl"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'tradeNo': function (row, colName, colValue, rowIndex, colConf) {
                        if(!Utils.isNoB(row.goodsOrder.tradeNo)) {
                            return '<span>' + row.goodsOrder.tradeNo + '</span>';
                        }
                    },
                    'orderNo': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.orderFlag && self.checkActionPerm('to_order_list')) {
                            return '<span><a class="table-cell-link" ref="#">' + row.orderNo + '</a></span>';
                        } else {
                            return '<span>' + row.orderNo + '</span>';
                        }
                    },
                    'buyerBizUnitName': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.buyerShopId == row.buyerBizUnitId) {
                            return '<span>' + row.buyerBizUnitName + '</span>';
                        } else {
                            return '<span>' + row.buyerBizUnitName + '-' + row.buyerShopName + '</span>';
                        }
                    },
                    'returnAcceptState': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.returnAcceptState == 0) {
                            return '<span>未处理</span>';
                        } else if (row.returnAcceptState == 1) {
                            return '<span>已接受</span>';
                        } else if (row.returnAcceptState == -1) {
                            return '<span>已拒绝</span>'
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex, colConf) {
                        let btnList = [];
                        if (self.checkActionPerm('view_detail')) {
                            btnList.push({
                                name: 'view_detail',
                                text: '详情'
                            })
                        }
                        if (self.checkActionPerm('to_ship') && row.returnAcceptState == 1 && !row.returnSentFlag) {
                            btnList.push({
                                name: 'to_ship',
                                text: '发货'
                            })
                        }
                        if (self.checkActionPerm('replenish_logis_info') && row.returnAcceptState == 1 && row.returnSentFlag && Utils.isNoB(row.returnLogisExpNo)) {
                            btnList.push({
                                name: 'replenish_logis_info',
                                text: '补充物流信息'
                            })
                        }

                        return btnList
                    },
                }, /* 单元格按钮点击处理函数 */ {
                    'orderNo': function (row, colName, colValue, rowIndex, colConf) {
                        if (self.checkActionPerm('to_order_list')) {
                            self.toGoodsOrderInfo(row.goodsOrder.id)
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName, event) {
                        if (btnName == 'view_detail') { // 详情
                            self.goGoodsRecvVoucherInfo(row.id);
                        } else if (btnName == 'to_ship') { // 发货
                            self.shipGoodsRecvVoucher(row);
                        } else if (btnName == 'replenish_logis_info') { // 补充物流信息
                            self.toSetLogisComInfo(row);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },

            queryHandler(queryModel){
                console.log('----------  查询、排序参数 ---------');
                //1、接收查询条件
                this.queryModel = queryModel;
                //缓存查询条件
                console.log(queryModel);
                //
                this.pageNumber = 1;
                this.getGoodsRecvVouchers();
            },
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getGoodsRecvVouchers();
            },
            getGoodsRecvVouchers: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.ioFlag = -1;
                filterItems.deliverType = -1;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.getGoodsRecvVoucherList(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == "info") {
                        let goodsRecvVoucherList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pagesize = pagination.pageSize;

                        //
                        self.renderTable(goodsRecvVoucherList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            goGoodsRecvVoucherInfo: function (id) {
                showRouteLayer({
                    title: '退货单详情',
                    query: {id: id},
                    template: SwbGoodsReturnVoucherInfo
                });
            },
            // 发货
            shipGoodsRecvVoucher: function (goodsRecvVoucher) {
                let self = this;
                let params = {
                    title: '发货',
                    requiredFlag: false,
                    // merchantId: goodsRecvVoucher.sellerId
                };
                openLogisComSetDlg(params, function (logisCom, theDlg) {
                    goodsRecvVoucher.expectArriveDate = !Utils.isNoB(logisCom.expectArriveDate) ? logisCom.expectArriveDate.format("yyyy-MM-dd") : null;
                    goodsRecvVoucher.returnLogisComCode = logisCom.logisComCode;
                    goodsRecvVoucher.returnLogisComName = logisCom.logisComName;
                    goodsRecvVoucher.returnLogisExpNo = logisCom.logisExpNo;
                    goodsRecvVoucher.senderContactName = logisCom.senderContactName;
                    goodsRecvVoucher.senderContactTel = logisCom.senderContactTel;
                    theDlg.close();
                    //
                    let msgBoxDlg = MsgBox.loading();
                    goodsDelivApi.updateGoodsRecvAndShipLogis(goodsRecvVoucher, function (result) {
                        msgBoxDlg.close();
                        if (result.type === "info") {
                            self.getGoodsRecvVouchers();
                            MsgBox.success('发货成功!');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    })
                });
            },
            // 补充物流信息
            toSetLogisComInfo: function (goodsRecvVoucher) {
                let self = this;
                let params = {
                    requiredFlag: true,
                    // merchantId: goodsRecvVoucher.sellerId
                };
                openLogisComSetDlg(params, function (logisCom, theDlg) {
                    let postData = {
                        id: goodsRecvVoucher.id,
                        expectArriveDate: !Utils.isNoB(logisCom.expectArriveDate) ? logisCom.expectArriveDate.format("yyyy-MM-dd") : null,
                        returnLogisComCode: logisCom.logisComCode,
                        returnLogisComName: logisCom.logisComName,
                        returnLogisExpNo: logisCom.logisExpNo,
                    };
                    theDlg.close();
                    //
                    let msgBoxDlg = MsgBox.loading();
                    goodsDelivApi.setSetLogisComInfo(postData, function (result) {
                        msgBoxDlg.close();
                        if (result.type === "info") {
                            self.getGoodsRecvVouchers();
                            MsgBox.success('物流信息补充成功!');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    })
                });
            },
            // 跳转交易单
            goTradeVoucherList: function (goodsOrder) {
                let contractNo = goodsOrder.contractNo;
                let type = null;
                if (contractNo == null) {
                    type = 1;
                } else {
                    type = 2;
                }
                this.$router.push({
                    path: SwbTradeVoucherList.path,
                    query: {
                        tradeNo: goodsOrder.tradeNo,
                        type: type
                    }
                });
            },
            // 跳转商品定单详情
            toGoodsOrderInfo: function (goodsOrderId) {
                this.$router.push({
                    path: SwbShowGoodsOrder.path,
                    query: {
                        goodsOrderId: goodsOrderId
                    }
                });
            }
        }
    }
</script>






// WEBPACK FOOTER //
// src/compo/order/GoodsReturnVoucherList.vue